import { createContext } from "react";

// Global state OWNED by the User block: which notifications the signed-in user
// has opted into. Today that is one preference - the news subscription - but the
// context is named for the concept so adding a second does not rename anything.
//
// The object lives alone in this file so that the provider and the hook can each
// import it without importing each other. It is deliberately absent from
// context/index.js: nothing outside this folder pair should hold the raw context,
// because reading it directly would bypass the guard in useNotificationPreferences.
//
// The `undefined` default is load-bearing - it is the value that guard tests for.
export const NotificationPreferencesContext = createContext(undefined);
